import { useCallback, useEffect, useState } from "react";
import { CustomButton } from "../../../../components/CustomButton";
import { ContainerRules, ContainerTab, IconButtonPromo, TabHeaderRow, EmptyState, ListItemCard, InfoBanner } from "../styles"
import EditarCadastrarRegrasPromo from "./EditarCadastrar";
import { FaEdit, FaTrash, FaPlus, FaInfoCircle, FaExclamationTriangle } from "react-icons/fa";
import api from "../../../../services/api";
import DeletarRegrasPromo from "./Delete";
import { promotionsTypes } from "../../../../enums/promotionsTypes";

const RegrasPromocao = ({ promo, products }) => {
  const isCombo = promo?.Tipo === promotionsTypes.COMBO_PRECO_FIXO;
  const [rules, setRules] = useState([]);
  const [rule, setRule] = useState(null);
  const [modalCreate, setModalCreate] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);

  const loadRules = useCallback(async () => {
    await api.get(`promocao-regra/listar/${promo.Id}`)
    .then(response => setRules(response.data))
    .catch(error => console.log('Erro ao listar regras ' + error))
  },[promo?.Id]);

  useEffect(() => {
    if(promo){
      loadRules();
    }
  },[loadRules, promo]);

  return (
    <>
      <ContainerTab>
        <TabHeaderRow>
          <h3>Produtos que ativam a promoção</h3>
          <CustomButton
            appearance="primary"
            onClick={() => {
              setRule(null)
              setModalCreate(true);
            }}>
            Adicionar Regra
          </CustomButton>
        </TabHeaderRow>

        {rules.length === 0 ? (
          isCombo ? (
            <InfoBanner variant="warning">
              <FaExclamationTriangle size={14} />
              <span>
                <b>Obrigatório para Combo preço fixo:</b> adicione abaixo os produtos que compõem o combo.
                Sem produtos aqui, a promoção não pode ser ativada ela ficará <b>inativa</b> até ser configurada.
              </span>
            </InfoBanner>
          ) : (
            <InfoBanner variant="warning">
              <FaExclamationTriangle size={14} />
              <span>
                <b>Nenhum produto selecionado:</b> Para criar uma promoção do tipo Combo, é necessário cadastrar os produtos participantes.
                Adicione as regras abaixo selecionando os itens e quantidades que compõem este combo.
              </span>
            </InfoBanner>
          )
        ) : (
          <InfoBanner variant="info">
            <FaInfoCircle size={14} />
            <span>
              Esta promoção está restrita aos produtos listados abaixo. Para que ela volte a valer para todos os produtos, remova todas as regras.
            </span>
          </InfoBanner>
        )}

        <ContainerRules>
          {rules.length === 0 ? (
            <EmptyState>
              <p>Nenhuma regra cadastrada ainda.</p>
              <span style={{ fontSize: 12 }}>Adicione os produtos que o cliente precisa comprar para ativar esta promoção.</span>
              <CustomButton appearance="ghost" onClick={() => { setRule(null); setModalCreate(true); }}>
                <FaPlus size={10} style={{ marginRight: 6 }} /> Adicionar Primeira Regra
              </CustomButton>
            </EmptyState>
          ) : (
            rules.map((item) => (
              <ListItemCard key={item.Id}>
                <div className="info-group">
                  <span className="title">{item.DescricaoProduto}</span>
                  <span className="subtitle">
                    <b>Quantidade exigida:</b> {item.Quantidade} {item.Quantidade > 1 ? 'unidades' : 'unidade'}
                  </span>
                </div>
                <div className="actions">
                  <IconButtonPromo onClick={() => { setRule(item); setModalCreate(true) }}>
                    <FaEdit size={16} color="#64748b" />
                  </IconButtonPromo>
                  <IconButtonPromo onClick={() => { setRule(item); setModalDelete(true) }}>
                    <FaTrash size={16} color="#ef4444"/>
                  </IconButtonPromo>
                </div>
              </ListItemCard>
            ))
          )}
        </ContainerRules>
      </ContainerTab>

      {modalCreate &&
        <EditarCadastrarRegrasPromo
          open={modalCreate}
          handleClose={() => setModalCreate(false)}
          rule={rule}
          promo={promo}
          setRules={setRules}
          products={products}
        />}
      {modalDelete &&
        <DeletarRegrasPromo
          open={modalDelete}
          handleClose={() => setModalDelete(false)}
          rule={rule}
          setRule={setRule}
          setRules={setRules}
        />}
    </>
  )
}

export default RegrasPromocao;
